import React from "react";

interface CategoryViewModalProps {
  category: null | string;
  onClose: () => void;
  open: boolean;
}

const CategoryViewModal: React.FC<CategoryViewModalProps> = ({
  category,
  onClose,
  open,
}) => {
  if (!open || !category) return null;
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div
        className="w-full max-w-md rounded-lg bg-white p-6 shadow-lg dark:bg-gray-900"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 className="mb-4 text-xl font-bold text-gray-900 dark:text-gray-100">
          View Category
        </h2>
        <div className="space-y-2">
          <div>
            <span className="font-semibold">Category:</span> {category}
          </div>
        </div>
        <button
          className="mt-6 rounded bg-blue-600 px-4 py-2 text-white"
          onClick={onClose}
        >
          Close
        </button>
      </div>
    </div>
  );
};

export default CategoryViewModal;
